import { Box, Button, Stack, Typography } from '@mui/material'
import { useContext } from 'react'
import { useNavigate } from 'react-router-dom'

import DviPage from '../../components/DviPage/DviPage'
import { DviTimeClockProductivityCard } from '../../components/TimeClockCard/DviTimeClockProductivityCard'
import useAccessTokenAndShopId from '../../hooks/useAccessTokenAndShopId/useAccessTokenAndShopId'
import { AppRoutes } from '../../models'
import { FeatureFlags } from '../../models/FeatureFlags'
import { AuthContext } from '../../providers'
import { AppContext } from '../../providers/AppProvider/AppProvider'
import { DviListContext } from '../../providers/DviListProvider/DviListProvider'
import DviHomeActiveJobsList from './DviHomeActiveJobsList'
import DviHomeInspectionList from './DviHomeInspectionList'

function DviHome() {
  const { currentUser } = useContext(AuthContext)
  const { userId } = useAccessTokenAndShopId()
  const navigate = useNavigate()
  const { isLoading } = useContext(DviListContext)
  const { featureFlags } = useContext(AppContext)
  return (
    <DviPage title="Home" isLoading={isLoading} noXpadding>
      <Stack
        sx={{ overflowY: 'hidden', overflowX: 'hidden' }}
        spacing={1}
        alignItems="center">
        <Stack
          direction="column"
          alignItems="center"
          justifyContent="center"
          spacing={2}
          sx={{ flexGrow: 1 }}>
          <Typography variant="h4" textAlign={'center'}>
            <b>{`Hi ${currentUser?.name}!`}</b>
          </Typography>
          <Typography textAlign={'center'}>
            Welcome to the InTune DVI application
          </Typography>
        </Stack>
        {featureFlags && featureFlags[FeatureFlags.TimeClock] && (
          <Box sx={{ width: '100%', px: 1 }}>
            <DviTimeClockProductivityCard employeeId={userId} />
          </Box>
        )}
        <Stack
          direction="row"
          alignItems="center"
          justifyContent="space-between"
          sx={{ width: '100%' }}>
          <Typography variant="h4" paddingLeft={2}>
            <b>Inspection List</b>
          </Typography>
          <Button onClick={() => navigate(AppRoutes.DVI_INSPECTIONS)}>
            Show All
          </Button>
        </Stack>
        <DviHomeInspectionList />
        <Stack
          direction="row"
          alignItems="center"
          justifyContent="space-between"
          sx={{ width: '100%' }}>
          <Typography variant="h4" paddingLeft={2}>
            <b>Active Jobs</b>
          </Typography>
          <Button onClick={() => navigate(AppRoutes.DVI_JOBS)}>Show All</Button>
        </Stack>
        <DviHomeActiveJobsList />
      </Stack>
    </DviPage>
  )
}

export default DviHome
